class r {
  constructor() {
  }
  validate(a, t) {
    const s = a.dataset.min * 1, n = a.dataset.max * 1;
    return t = t * 1, t >= s && t <= n;
  }
}
export {
  r as default
};
